module.exports = __webpack_public_path__ + "img/bg_main_quick_bottom.c62bdce.png";